export const TIPO_EVENTO_LABELS: Record<string, string> = {
  visita: 'Visita',
  reuniao: 'Reunião',
  ligacao_agendada: 'Ligação Agendada',
  vistoria: 'Vistoria',
  assinatura: 'Assinatura',
  atendimento: 'Atendimento',
  captacao: 'Captação',
  outro: 'Outro',
};

export const STATUS_EVENTO_LABELS: Record<string, string> = {
  agendado: 'Agendado',
  confirmado: 'Confirmado',
  realizado: 'Realizado',
  cancelado: 'Cancelado',
  reagendado: 'Reagendado',
};

export const STATUS_EVENTO_BADGE: Record<string, string> = {
  agendado: 'badge-info',
  confirmado: 'badge-success',
  realizado: 'badge-neutral',
  cancelado: 'badge-error',
  reagendado: 'badge-warning',
};

export const PRIORIDADE_COMPROMISSO_LABELS: Record<string, string> = {
  alta: 'Alta',
  media: 'Média',
  baixa: 'Baixa',
};

export const PRIORIDADE_COMPROMISSO_BADGE: Record<string, string> = {
  alta: 'badge-error',
  media: 'badge-warning',
  baixa: 'badge-secondary',
};

export const STATUS_TAREFA_LABELS: Record<string, string> = {
  pendente: 'Pendente',
  em_andamento: 'Em Andamento',
  aguardando_terceiros: 'Aguardando Terceiros',
  concluida: 'Concluída',
  cancelada: 'Cancelada',
};

export const STATUS_TAREFA_BADGE: Record<string, string> = {
  pendente: 'badge-neutral',
  em_andamento: 'badge-info',
  aguardando_terceiros: 'badge-warning',
  concluida: 'badge-success',
  cancelada: 'badge-error',
};

// Ordem fixa das colunas do Kanban de Tarefas — mesma convenção de
// LeadKanbanBoard, mas com um enum fixo em vez de catálogo tenant.
export const STATUS_TAREFA_ORDEM: string[] = [
  'pendente', 'em_andamento', 'aguardando_terceiros', 'concluida', 'cancelada',
];

export const PRIORIDADE_TAREFA_LABELS: Record<string, string> = {
  baixa: 'Baixa',
  media: 'Média',
  alta: 'Alta',
  urgente: 'Urgente',
};

export const PRIORIDADE_TAREFA_BADGE: Record<string, string> = {
  baixa: 'badge-secondary',
  media: 'badge-info',
  alta: 'badge-warning',
  urgente: 'badge-error',
};

export const MODULO_ORIGEM_TAREFA_LABELS: Record<string, string> = {
  lead: 'Lead',
  pessoa: 'Pessoa',
  imovel: 'Imóvel',
  locacao: 'Locação',
  processo_juridico: 'Processo Jurídico',
  caso_juridico: 'Caso Jurídico',
  agenda: 'Agenda',
  manual: 'Manual',
};

export const TIPO_NOTIFICACAO_LABELS: Record<string, string> = {
  tarefa_atribuida: 'Tarefa atribuída',
  tarefa_prazo_proximo: 'Prazo de tarefa próximo',
  tarefa_status_alterado: 'Status de tarefa alterado',
  compromisso_lembrete: 'Lembrete de compromisso',
  compromisso_alterado: 'Compromisso alterado',
  lembrete_processado: 'Lembrete processado',
  outro: 'Outro',
};

export const REPETICAO_LEMBRETE_LABELS: Record<string, string> = {
  nenhuma: 'Não repetir',
  diaria: 'Diariamente',
  semanal: 'Semanalmente',
  mensal: 'Mensalmente',
};

export const AGENDA_ITEM_ORIGEM_LABELS: Record<string, string> = {
  compromisso: 'Compromisso',
  audiencia: 'Audiência',
  vistoria: 'Vistoria',
  prazo: 'Prazo Jurídico',
};

export const TIPO_EVENTO_OPERACIONAL_LABELS: Record<string, string> = {
  tarefa_criada: 'Tarefa criada',
  tarefa_atribuida: 'Tarefa atribuída',
  tarefa_status_alterado: 'Status de tarefa alterado',
  tarefa_concluida: 'Tarefa concluída',
  tarefa_cancelada: 'Tarefa cancelada',
  compromisso_criado: 'Compromisso criado',
  compromisso_status_alterado: 'Status de compromisso alterado',
  compromisso_cancelado: 'Compromisso cancelado',
  lembrete_criado: 'Lembrete criado',
  lembrete_processado: 'Lembrete processado',
  notificacao_enviada: 'Notificação enviada',
  // Sprint 3.3 — Gestão Comercial / Vendas
  negociacao_criada: 'Negociação criada',
  negociacao_etapa_alterada: 'Etapa da negociação alterada',
  negociacao_visita_agendada: 'Visita agendada',
  negociacao_proposta_registrada: 'Proposta registrada',
  negociacao_valor_alterado: 'Valor da negociação alterado',
  negociacao_ganha: 'Negociação ganha',
  negociacao_perdida: 'Negociação perdida',
};

export type CalendarioView = 'dia' | 'semana' | 'mes' | 'lista' | 'timeline';

export const CALENDARIO_VIEW_LABELS: Record<CalendarioView, string> = {
  dia: 'Dia',
  semana: 'Semana',
  mes: 'Mês',
  lista: 'Lista',
  timeline: 'Timeline',
};
